import { DynamicDataContext } from "@common/build/activeEntityType";
import { searchVectorData, searchByDescription } from "../resources/searchResources";
import { editDynamicGrid } from "./advancedElements/dynamicGrids";
import { getCleanJSX } from "@builder/utils/JSXtoBuilder";
import { getLayerById } from "./helpers";

export const findDynamicData = async (
    query?: string, 
    context?: DynamicDataContext,
    numberOfResults?: number
) => {
    const contextFilter = context ? 
      (item: any) => !item.hide && item.metadata?.allowedInContext?.includes(context) :
      undefined;
    
    const searchResults = await searchVectorData<string>("vectors/dynamicData", query, {
        numberOfResults: numberOfResults || (query ? 5 : 20),
        threshold: query ? 0.7 : 0,
        filter: contextFilter
    });
    
    if (searchResults.length === 0) {
        console.log("no dynamic data found", query, context);
        return `No dynamic data found${query ? ` for "${query}"` : ''}${context ? ` in context "${context}"` : ''}`;
    }
    
    console.log("searched dynamic data, found", searchResults);

    return searchResults.map(result => {
        return {
            key: result.value,
            description: result.description,
            dataType: result.metadata?.dataType,
            score: result.score
        }
    })
}



export const editOrCreateDynamicGrid = async ({
    instructions,
    gridType,
    layerId,
    existingGridId,
}: {
    instructions: string;
    gridType: "product" | "order" | "customer";
    layerId: string;
    existingGridId?: string;
}): Promise<string> => {

    console.group("calling editOrCreateDynamicGrid");

    console.log("existingGridId", existingGridId);
 
    const layer = getLayerById(layerId);
    if (!layer) {
        console.error("Layer not found");
        return "Layer not found";
    }

    const existingComponentsJSX = existingGridId ? getCleanJSX(layer.layer, existingGridId) : undefined;
    // looking for inspiration:
    const resourceMap: Record<"product" | "order" | "customer", string> = {
            product: "usefulBlocks/productLists",
            order: "usefulBlocks/orderLists",
            customer: "usefulBlocks/customerLists",
    };
    const resourcePath = resourceMap[gridType];
    const templates = await searchByDescription<string>(resourcePath, `find a template that would be most useful for the following instructions. Return at least 1 result: ${instructions}`, { numberOfResults: 2 });
    


    const newGridJSX = await editDynamicGrid({gridType, existingComponentsJSX, instructions, templates});
    console.log("newGridJSX:");
    console.log(newGridJSX);
    console.groupEnd();

    return newGridJSX;
};

// @ts-ignore
window.editOrCreateDynamicGrid = editOrCreateDynamicGrid;